import { render, staticRenderFns } from "./DigitalRecordFilters.vue?vue&type=template&id=bff08f54"
import script from "./DigitalRecordFilters.vue?vue&type=script&lang=js"
export * from "./DigitalRecordFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports